"use strict";
(self["webpackChunkshop_chunks"] = self["webpackChunkshop_chunks"] || []).push([[654],{

/***/ 8654:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9755);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);


const ProductPage = function () {
  const mediaMap = new Map()
  const variantMap = new Map()
  const mediaSlides = document.querySelectorAll('[data-product-media-slide]')
  const idInput = document.querySelector('[data-product-select')
  const productData = JSON.parse(document.querySelector('[data-product-json]').textContent)
  for (const variant of productData.variants) {
    variantMap.set(variant.id + '', variant.featured_media.id + '')
  }
  mediaSlides.forEach((slide) => {
    const id = slide.getAttribute('data-media-id')
    const index = slide.getAttribute('data-media-index')
    mediaMap.set(id, index)
  })

  const slick = jquery__WEBPACK_IMPORTED_MODULE_0___default()('.product-slick-slider-container')[0]

  idInput.addEventListener('change', (event) => {
    const id = event.target.value
    const index = mediaMap.get(variantMap.get(id))
    slick.slick.slickGoTo(index)
  })
}

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ProductPage);


/***/ })

}]);